<ion-grid>
	<ion-row>
		<ion-col size="auto">
			<ion-button
				class="{{ classes }}"
				(click)="fileInsp.click()"
				*ngIf="!iconOnly"
			>
				<span *ngIf="!isLoading; else loading">
					{{ text }}
				</span>
				<ng-template #loading>
					<span>
						{{ loadingText }}
						<ion-spinner
							name="crescent"
							class="text-black"
							style="height: 16px;"
						></ion-spinner>
					</span>
				</ng-template>
			</ion-button>
			<ion-icon
				class="{{ classes }}"
				(click)="fileInsp.click()"
				*ngIf="iconOnly"
				[name]="name"
			>
			</ion-icon>

			<input
				type="file"
				(change)="handleFileInput($event)"
				#fileInsp
				class="file-input"
				[accept]="acceptType"
			/>
		</ion-col>
	</ion-row>
</ion-grid>
